export default {
    baseUrl: "https://1f52ibi5e3.execute-api.us-east-1.amazonaws.com/",
    urlEnv: "dev/",
    householdId:""
}